export const LANGUAGES = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "th", name: "ไทย" },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]["code"];

export const PSEUDO_LANGUAGE = "en-XA";

const SESSION_KEY = "eclipse_language";
const DEVICE_KEY = "eclipse_language_device";

const isSelectable = (code: string | null): code is string =>
  code !== null && (LANGUAGES.some(language => language.code === code) || (import.meta.env.DEV && code === PSEUDO_LANGUAGE));

const read = (storage: () => Storage, key: string) => {
  try {
    return storage().getItem(key);
  } catch {
    return null;
  }
};

const write = (storage: () => Storage, key: string, value: string) => {
  try {
    storage().setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

const remember = (code: string) => {
  write(() => sessionStorage, SESSION_KEY, code);
  write(() => localStorage, DEVICE_KEY, code);
};

export function startupLanguage(): string {
  const url = new URL(window.location.href);
  const requested = url.searchParams.get("lang");

  if (requested !== null) {
    url.searchParams.delete("lang");
    window.history.replaceState(window.history.state, "", url);
    if (isSelectable(requested)) {
      remember(requested);
      return requested;
    }
  }

  const stored = [read(() => sessionStorage, SESSION_KEY), read(() => localStorage, DEVICE_KEY)];
  return stored.find(isSelectable) ?? "en";
}

// Note: switching reloads rather than re-rendering in place, because every luxon DateTime keeps the
// locale it was created with, including the ones already parsed into the query cache.
export function switchLanguage(code: LanguageCode) {
  remember(code);
  window.location.reload();
}
